import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { Img } from 'atoms/ui/Img';
import { TextWithLine } from 'atoms/ui/TextWithLine';
import { tabletAndAbove } from 'style/mediaQuery';

import gpAvif from './assets/gerard-pique.avif';
import gp from './assets/gerard-pique.jpg';
import kmAvif from './assets/kylian-mbappe.avif';
import km from './assets/kylian-mbappe.jpg';
import rfAvif from './assets/rio-ferdinand.avif';
import rf from './assets/rio-ferdinand.jpg';

const Pictures = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--double-unit);
  align-items: center;
  :nth-child(2) {
    /** mbappe comes first on mobile */
    order: -1;
  }
  @media ${tabletAndAbove} {
    flex-direction: row;
    justify-content: space-between;
    :nth-child(2) {
      /** mbappe stays in the middle on desktop */
      order: unset;
    }
  }
`;

const Image = styled(Img)`
  border-radius: 12px;
`;

export const Ambassadors = () => {
  const { formatMessage } = useIntl();
  return (
    <Vertical gap={2}>
      <TextWithLine>
        <FormattedMessage
          id="landing.EarlyAccess.Ambassadors.title"
          defaultMessage="Sorare Partners & Investors"
        />
      </TextWithLine>
      <Pictures>
        <picture>
          <source srcSet={rfAvif} type="image/avif" />
          <Image
            src={rf}
            alt={formatMessage({
              id: 'landing.EarlyAccess.Ambassadors.rf',
              defaultMessage: 'Rio Ferdinand, Sorare investor',
            })}
            width="368"
            height="532"
            fetchpriority="low"
          />
        </picture>
        <picture>
          <source srcSet={kmAvif} type="image/avif" />
          <Image
            src={km}
            alt={formatMessage({
              id: 'landing.EarlyAccess.Ambassadors.km',
              defaultMessage: 'Kylian Mbappé, Sorare ambassador',
            })}
            width="368"
            height="532"
            fetchpriority="low"
          />
        </picture>
        <picture>
          <source srcSet={gpAvif} type="image/avif" />
          <Image
            src={gp}
            alt={formatMessage({
              id: 'landing.EarlyAccess.Ambassadors.gp',
              defaultMessage: 'Gerard Piqué, Sorare investor',
            })}
            width="368"
            height="532"
            fetchpriority="low"
          />
        </picture>
      </Pictures>
    </Vertical>
  );
};
